import * as React from "react";

interface FaviconProps extends React.HTMLAttributes<SVGSVGElement> {
  size?: number | string;
}

function Favicon({ size = 32, ...props }: Readonly<FaviconProps>) {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 512 512"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0h512v512H0z" />
      <path
        fill="#77AD54"
        d="M396.8 108.8c-5.333 0-18.133 16-24.533 23.467C355.2 153.6 328.533 185.6 288 177.067S236.8 128 230.4 101.333c-2.133-9.6-7.467-29.866-11.733-32l12.8-58.666c40.533 8.533 51.2 49.066 57.6 75.733 2.133 9.6 7.466 29.867 11.733 32 5.333 0 18.133-16 24.533-23.467C342.4 73.6 369.067 41.6 409.6 50.133z"
      />
      <path
        fill="#175D71"
        d="M458.667 418.133C453.333 416 443.733 397.867 438.4 387.2c-13.867-27.733-34.133-68.267-80-68.267s-67.2 41.6-80 68.267c-5.333 9.6-14.933 29.867-21.333 32-5.334-2.133-16-22.4-20.267-32-13.867-27.733-34.133-68.267-81.067-68.267-45.866 0-67.2 41.6-81.066 68.267-5.334 9.6-14.934 28.8-21.334 30.933V486.4c45.867 0 67.2-41.6 81.067-68.267 5.333-9.6 14.933-29.866 21.333-32 5.334 2.134 16 22.4 20.267 32 13.867 27.734 34.133 68.267 81.067 68.267 45.866 0 67.2-41.6 81.066-68.267 5.334-9.6 14.934-29.866 21.334-32 5.333 2.134 16 22.4 20.266 32 13.867 27.734 34.134 68.267 80 68.267v-68.267z"
      />
    </svg>
  );
}

export { Favicon };
